import React from 'react';
import cx from 'classnames';

import {Bar} from '@pexip/components';

import styles from './DesktopMeetingToolbar.module.scss';

export const DesktopMeetingToolbar: React.FC<
    React.ComponentProps<typeof Bar> & {
        core?: React.ReactNode;
        withSidePanel?: boolean;
        withBoxShadow?: boolean;
    }
> = ({
    core,
    withSidePanel = false,
    withBoxShadow = true,
    className,
    ...props
}) => {
    return (
        <Bar
            flexDirection="column"
            className={cx(
                styles.toolbar,
                {
                    [styles.withSidePanel]: withSidePanel,
                    [styles.withBoxShadow]: withBoxShadow,
                },
                className,
            )}
            {...props}
        >
            {core && <div className={styles.core}>{core}</div>}
        </Bar>
    );
};
